import { createAction, createReducer } from 'deox';
import { resetApplication } from './resetApplication';

export interface Prescreen {
  virtualLookupSuccessful: boolean;
  prescreenId?: string;
}

const defaultState: Prescreen = {
  virtualLookupSuccessful: false,
  prescreenId: undefined,
};

export const setVirtualLookupSuccessful = createAction(
  'SET_VIRTUAL_LOOKUP_SUCCESSFUL',
  resolve => (virtualLookupSuccessful: boolean) =>
    resolve(virtualLookupSuccessful),
);

export const setPrescreenId = createAction(
  'SET_PRESCREEN_ID',
  resolve => (prescreenId: string) => resolve(prescreenId),
);

export const prescreenReducer = createReducer(defaultState, handleAction => [
  handleAction(
    setVirtualLookupSuccessful,
    (state, { payload: virtualLookupSuccessful }) => ({
      ...state,
      virtualLookupSuccessful,
    }),
  ),
  handleAction(setPrescreenId, (state, { payload: prescreenId }) => ({
    ...state,
    prescreenId,
  })),
  handleAction(resetApplication, () => defaultState),
]);

interface MountedState {
  prescreen: Prescreen;
}

export const selectVirtualLookupSuccessful = (state: MountedState): boolean => {
  return state.prescreen.virtualLookupSuccessful;
};

export const selectPrescreenId = (state: MountedState): string | undefined => {
  return state.prescreen.prescreenId;
};

export default prescreenReducer;
